import React from "react";

// This component is a copy of
// https://github.com/mozilla-services/react-jsonschema-form/blob/e4378c2a0b738eeee151e82c4533d2a79b80346c/src/components/fields/SchemaField.js#L50L62
// The Label function defined by RJSF is not exported, so there's no way to re-use it

const REQUIRED_FIELD_SYMBOL = "*";

export default (props) => {
  const { label, required, id } = props;
  if (!label) {
    // See #312: Ensure compatibility with old versions of React.
    return <div />;
  }
  return (
    <label key={0} className="control-label" htmlFor={id}>
      {label}
      {required && <span className="required">{REQUIRED_FIELD_SYMBOL}</span>}
    </label>
  );
}
